const gameCode = "smtl2";
const activityCode = "smtl2Pre2";
const language = "zh-CN";
const platform = "en";
const fbAppId = "666298277871993";

const baseUrl = "https://efe-activity.efun.com/";
const apiUrl = {
  pre: baseUrl + "common-pre",
  proUrlPre: baseUrl + "common-pre/",
  graphql: baseUrl + "graphql",
  configProUrl: baseUrl + "common/public/",
  getDynamicFbShareKey: baseUrl + "util/fb-dynamic-share/",
  teamProUrl: baseUrl + "team/",
  proUrlReward: baseUrl + "team/",
};
const webActivityUrl = !location.port ?
  "https://tlbb2.efunen.com/event/pre2/" :
  location.href;
const redirectUrl = !location.port ?
  "https://tlbb2.efunen.com/event/pre2/index.html" :
  location.href;

const gaAction = {
  click: "点击",
  clickLink: "点击-跳转",
  clickClose: "点击-关闭",
  clickOpen: "点击-打开",
}

/* 预约接口链接前缀 */
const gaInfo = {
  // 首页
  ".btn-ios": {
    category: "点击App Store立即预约按钮",
    action: gaAction.clickLink,
    label: "前往App Store预约用户",
  },
  ".btn-gg": {
    category: "点击Google Play立即预约按钮",
    action: gaAction.clickLink,
    label: "前往Google Play预约用户",
  },
  ".btn-login": {
    category: "点击登入Facebook按钮",
    action: gaAction.clickLink,
    label: "前往FB登录用户",
  },
  ".btn-record": {
    category: "点击查询奖励按钮",
    action: gaAction.clickOpen,
    label: "查看奖励用户",
  },
  // 寻参救阿紫
  ".btn-finish": {
    category: "点击完成按钮",
    action: gaAction.click,
    label: "完成测试用户",
  },
  // 江湖有传言
  ".btn-confirm-msg": {
    category: "点击确认按钮",
    action: gaAction.click,
    label: "完成留言用户",
  },
  // 大理集市
  ".fb-share": {
    category: "点击今日分享按钮",
    action: gaAction.clickLink,
    label: "每日分享用户",
  },
  ".task-name4": {
    category: "点击兄弟即信念按钮",
    action: gaAction.clickLink,
    label: "前往参与兄弟即信念用户",
  },
  ".task-name5": {
    category: "点击帮会集结共战雁门关按钮",
    action: gaAction.clickLink,
    label: "前往参与帮会集结用户",
  },
};
const rewardConfigPid = 841;


const lozads = [".lazy"];


export {
  gaAction,
  rewardConfigPid,
  fbAppId,
  webActivityUrl,
  redirectUrl,
  gameCode,
  activityCode,
  language,
  platform,
  gaInfo,
  apiUrl,
  lozads,
};